import { render, staticRenderFns } from "./RoundedLinkedinIcon.vue?vue&type=template&id=67e62860"
import script from "./RoundedLinkedinIcon.vue?vue&type=script&lang=js"
export * from "./RoundedLinkedinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports